module.exports = __webpack_public_path__ + "img/logo_ru.04ac75cf.svg";